import * as React from "react";
const SvgMinimize = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 12H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round" }));
export default SvgMinimize;
